/** @format */
import Master from '../Layouts/Master';
import ErrorMessage from '../../Shared/Components/ErrorMessage';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import { useContext, useState } from 'react';
import { EventContext } from '../../Contexts/EventContext';
import useApi from '../../Shared/hooks/api/Index';
import { error, success } from '../../Shared/Components/Toast';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Loading from '../../Shared/Components/Loading';

const validationSchema = Yup.object().shape({
	name: Yup.string()
		.required('عنوان الزامی است')
		.max(190, 'عنوان نمیتواندبیشتر از 190 کاراکتر باشد'),
});

const EditOrganizer = () => {
	const navigate = useNavigate();
	const { id } = useParams();
	const eventContext = useContext(EventContext);
	const [loading, setLoading] = useState(false);
	const [submitFormLoading, setSubmitFormLoading] = useState(false);

	useEffect(() => {
		const getOrganizer = async () => {
			setLoading(true);
			await useApi.get(
				`/organizer/${id}`,
				{},
				(res) => {
					eventContext.organizer = res.data.data;
					setLoading(false);
				},
				(err) => {
					setLoading(false);
					error('خطایی درهنگام دریافت اطلاعات پیش آمده است.');
				},
			);
		};
		getOrganizer();
	}, [id]);

	const onSubmitForm = async (values, setSubmitting) => {
		setSubmitFormLoading(true);

		await useApi.put(
			`/organizer/${id}`,
			values,
			(res) => {
				success('برگزار کننده با موفقیت ایجاد شد');
				navigate('/panel/organizer', { replace: true });
			},
			(err) => {
				setSubmitFormLoading(false);
				error('خطایی در ثبت اطلاعات پیش آمده است.');
			},
		);
	};

	return loading ? (
		<Loading />
	) : (
		<Master>
			<Formik
				initialValues={{
					name: eventContext.organizer.name,
				}}
				onSubmit={(values, { setSubmitting }) => {
					onSubmitForm(values, setSubmitting);
				}}
				validationSchema={validationSchema}>
				{({
					values,
					errors,
					handleChange,
					handleSubmit,
					isSubmitting,
					setFieldValue,
				}) => (
					<form onSubmit={handleSubmit}>
						<div className='d-flex flex-column border rounded p-2 mt-3'>
							<div className='w-100 form-group d-flex flex-row'>
								<div className='w-100 d-flex flex-column mt-1 mx-2'>
									<label>عنوان برگزار کننده</label>
									<input
										name='name'
										value={values.name}
										onChange={handleChange}
										type='text'
										className='form-control'
									/>
									<ErrorMessage error={errors.name} />
								</div>
							</div>
						</div>
						<div className='d-flex flex-row justify-content-end'>
							<button className='btn btn-info btn-sm f-14'>
								{submitFormLoading ? (
									<div
										className='spinner-border spinner-border-sm text-white mb-1'
										role='status'></div>
								) : (
									'ثبت برگزار کننده'
								)}
							</button>
						</div>
					</form>
				)}
			</Formik>
		</Master>
	);
};

export default EditOrganizer;
